import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from "react";

/**
 * Botão base (Design.md §9). Variante `primary` = laranja (`--orange`), a cor de
 * ação do produto (§3.2/§10). Componente de referência do padrão de estilo:
 * estilos inline + `var(--token)`, sem classes.
 */
export type ButtonVariant = "primary" | "secondary" | "ghost";

export interface ButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "style"> {
  variant?: ButtonVariant;
  fullWidth?: boolean;
  style?: CSSProperties;
}

const VARIANT_STYLE: Record<ButtonVariant, CSSProperties> = {
  primary: {
    background: "var(--orange)",
    color: "var(--on-orange)",
    border: "1px solid transparent"
  },
  secondary: {
    background: "var(--panel)",
    color: "var(--text)",
    border: "1px solid var(--border)"
  },
  ghost: {
    background: "transparent",
    color: "var(--text)",
    border: "1px solid transparent"
  }
};

export function Button({
  variant = "primary",
  fullWidth = false,
  type = "button",
  style,
  children,
  ...rest
}: ButtonProps): ReactNode {
  const merged: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.4rem",
    padding: "0.5rem 0.9rem",
    borderRadius: 8,
    fontWeight: 600,
    fontSize: 13,
    cursor: "pointer",
    width: fullWidth ? "100%" : "auto",
    ...VARIANT_STYLE[variant],
    // `style` é opcional; sob exactOptionalPropertyTypes espalhamos só quando
    // existe, evitando atribuir `undefined` às propriedades.
    ...(style ?? {})
  };

  return (
    <button type={type} style={merged} {...rest}>
      {children}
    </button>
  );
}
